import { createContext, useContext } from 'react';

const defaultValue = { isGridEditDisabled: false };

export const GridContext = createContext(defaultValue);

export const useGridContext = () => useContext(GridContext);
